import Big from 'big.js'
import type { Currency } from '@sequencehq/api'
import {
  type ListedInvoiceAmount,
  type ListedInvoiceAmountBasis,
  toListedInvoiceAmountValue
} from 'Invoices/utils'

export type InvoiceForTotal = ListedInvoiceAmount

export type CurrencyTotal = {
  currency: Currency
  count: number
  total: string
}

/** Sum displayed amounts within each currency to preserve display rounding. */
export const sumByCurrency = (
  invoices: ReadonlyArray<InvoiceForTotal>,
  basis: ListedInvoiceAmountBasis
): CurrencyTotal[] => {
  const byCurrency = invoices.reduce<
    Map<Currency, { count: number; total: Big }>
  >((acc, invoice) => {
    const displayedTotal = toListedInvoiceAmountValue({
      invoice: { ...invoice, grossTotal: invoice.grossTotal || '0' },
      basis
    })
    const existing = acc.get(invoice.currency)

    if (existing) {
      existing.count += 1
      existing.total = existing.total.plus(displayedTotal)
    } else {
      acc.set(invoice.currency, {
        count: 1,
        total: new Big(displayedTotal)
      })
    }

    return acc
  }, new Map())

  return Array.from(byCurrency, ([currency, { count, total }]) => ({
    currency,
    count,
    total: total.toString()
  }))
}
